/**
 * Created by mac on 1/25/21
 */

const VirtualProducts = {}; 

VirtualProducts.initialize = function () {
    const buyLivesTile = {
        prefab: bundles.tile_shop.jsons.livesproducttile_prefab_json,
        isEnabled: function () {
            return true;
        }
    };

    const unlimitedLivesTile = {
        prefab: bundles.tile_shop.jsons.livesproducttile_prefab_json,
        isEnabled: function () {
            return cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR;
        }
    };

    const askLivesTile = {
        prefab: bundles.tile_shop.jsons.livesproducttile_prefab_json,
        isEnabled: function () {
            return cleverapps.flags.requestsEnabled;
        }
    };

    const videoLivesTile = {
        prefab: bundles.tile_shop.jsons.livesproducttile_prefab_json,
        isEnabled: function () {
            // Old LimitedVideoTileModel.isEnabled: a video tile stays listed while ads are supported
            // (the ads-limit cooldown only dims it - that is the source's isAvailable, not eligibility).
            // The inABExperiments gate is applied by ShopProductSource.isProductEnabled.
            return this.free || connector.ads.isRewardedSupported;
        }
    };

    const buyEnergyTile = {
        prefab: bundles.tile_shop.jsons.livesproducttile_prefab_json,
        isEnabled: function () {
            const available = function (product) {
                if (product.price === 0) {
                    return true;
                }
                const timeout = (typeof product.timeout === "function" ? product.timeout() : product.timeout) || 0;
                const buyTimes = cleverapps.meta.getSelectedLocation().slot.load("local_energy_products") || {};
                return Date.now() >= timeout + (buyTimes[product.itemId] || 0);
            };

            if (!available(this)) {
                return false;
            }

            // Hide this energy tier when a cheaper enabled + purchasable tier is still on offer.
            if (this.disableProductIds) {
                for (let i = 0; i < this.disableProductIds.length; ++i) {
                    const sibling = Product.CreateById(this.disableProductIds[i]);
                    if (!sibling) {
                        continue;
                    }
                    const enabled = (!sibling.inABExperiments || sibling.inABExperiments())
                        && (!sibling.isEnabled || sibling.isEnabled());
                    if (enabled) {
                        return false;
                    }
                }
            }
            return true;
        }
    };

    const energyLotteryTile = {
        prefab: bundles.tile_shop.jsons.livesproducttile_prefab_json,
        isEnabled: function () {
            const lottery = Map2dLocation.currentLocation.energyLottery;
            return Boolean(lottery && lottery.isAvailable());
        },
        isAttention: function () {
            const lottery = Map2dLocation.currentLocation.energyLottery;
            return Boolean(lottery && lottery.isReady());
        }
    };

    if (cleverapps.config.features.includes("lives")) {
        VirtualProducts.refillLives = {
            icon: "refillLives_5_png",
            title: "LivesShopWindow.products.refillLives",
            spentEvent: cleverapps.EVENTS.SPENT.LIVES,
            currency: "hard",
            type: Product.TYPE_HARD,
            price: (["olympics", "zenmatch", "woodenblock"].includes(cleverapps.config.name) ? 3 : 5) * RewardsConfig.OneLifePrice.hard,
            ...buyLivesTile
        };

        VirtualProducts.livesForVideo = {
            icon: "lives_for_video_json",
            title: "LivesShopWindow.products.livesForVideo",
            description: "LivesForVideoProduct.description",
            reward: RewardsConfig.LivesForVideo,
            type: Product.TYPE_ADS,
            adsLimit: function () {
                return AdsLimits.TYPES.LIVES;
            },
            ...videoLivesTile
        };

        VirtualProducts.askLives = {
            icon: "askLives_png",
            title: "LivesShopWindow.products.askLives",
            ...askLivesTile
        };

        if (cleverapps.config.type === "tile3") {
            VirtualProducts.unlimitedLives = {
                title: "UnlimitedLives.Title",
                description: "UnlimitedLives.Description",
                spentEvent: cleverapps.EVENTS.SPENT.LIVES,
                currency: "hard",
                type: Product.TYPE_HARD,
                price: 2199,
                reward: RewardsConfig.UnlimitedLives,
                icon: "unlimitedLives_png",
                animation: "animation",
                ...unlimitedLivesTile
            };

            VirtualProducts.buyLife = {
                icon: "life_1_png",
                title: "LivesShopWindow.products.buyLive",
                spentEvent: cleverapps.EVENTS.SPENT.LIVES,
                type: Product.TYPE_SOFT,
                currency: "hard",
                price: 180,
                reward: RewardsConfig.BuyLife,
                ...buyLivesTile
            };
        }
    }

    if (cleverapps.config.features.includes("energy")) {
        VirtualProducts.buyEnergy350 = {
            icon: "energy_for_coins_png",
            title: "LivesShopWindow.products.buyEnergy",
            rewardsIcon: "shop_energy_png",
            type: Product.TYPE_SOFT,
            currency: "soft",
            price: 350,
            reward: RewardsConfig.BuyEnergy350,
            discount: "66%",
            timeout: cleverapps.parseInterval("24 hour"),
            ...buyEnergyTile
        };

        VirtualProducts.buyEnergy700 = {
            icon: "energy_for_coins_png",
            title: "LivesShopWindow.products.buyEnergy",
            rewardsIcon: "shop_energy_png",
            type: Product.TYPE_SOFT,
            currency: "soft",
            price: 700,
            reward: RewardsConfig.BuyEnergy700,
            discount: "33%",
            disableProductIds: ["buyEnergy350"],
            timeout: cleverapps.parseInterval("24 hour"),
            ...buyEnergyTile
        };

        VirtualProducts.buyEnergy = {
            icon: "energy_for_coins_png",
            title: "LivesShopWindow.products.buyEnergy",
            rewardsIcon: "shop_energy_png",
            type: Product.TYPE_SOFT,
            currency: "soft",
            price: 1050,
            reward: RewardsConfig.BuyEnergy,
            disableProductIds: ["buyEnergy350", "buyEnergy700"],
            ...buyEnergyTile
        };

        if (cleverapps.config.type === "merge2") {
            delete VirtualProducts.buyEnergy350;
            delete VirtualProducts.buyEnergy700;
            delete VirtualProducts.buyEnergy;

            let price = 20;
            const disableProductIds = [];

            for (let i = 0; i < 10; i++) {
                const name = `buyEnergy${price}`;
                const current = i;
                VirtualProducts[name] = {
                    icon: "energy_for_coins_png",
                    inABExperiments: () => current < 3 || current < 5 && cleverapps.abExperiments.getGroup(ABExperiments.Tests.energySlots) === "A",
                    title: "LivesShopWindow.products.buyEnergy",
                    rewardsIcon: "shop_energy_png",
                    type: Product.TYPE_HARD,
                    currency: "hard",
                    timeout: () => (cleverapps.abExperiments.getGroup(ABExperiments.Tests.energySlots) === "A" ? current < 4 : current < 2) && cleverapps.parseInterval("24 hour"),
                    price,
                    reward: RewardsConfig.BuyEnergyMerge2,
                    disableProductIds: disableProductIds.slice(),
                    ...buyEnergyTile
                };
                disableProductIds.push(name);
                price *= 2;
            }
        }

        if (cleverapps.config.type === "match3") {
            [VirtualProducts.buyEnergy350, VirtualProducts.buyEnergy700, VirtualProducts.buyEnergy].forEach((product) => {
                product.type = Product.TYPE_HARD;
                product.currency = "hard";
                product.price = Math.max(1, Math.ceil(product.price * 0.5));
            });
        }

        VirtualProducts.energyLottery = {
            icon: "energy_lottery_png",
            title: "LivesShopWindow.products.energyLottery",
            attention: true,
            ...energyLotteryTile
        };

        VirtualProducts.energyForVideo = {
            icon: "energy_for_video_json",
            title: "LivesShopWindow.products.energyForVideo",
            description: "EnergyForVideoProduct.description",
            rewardsIcon: "shop_energy_png",
            reward: RewardsConfig.EnergyForVideo,
            type: Product.TYPE_ADS,
            adsLimit: function () {
                switch (cleverapps.lives.locationConfig.slotId) {
                    case Meta.EXPEDITION_SLOT1: return AdsLimits.TYPES.ENERGY_1;
                    case Meta.EXPEDITION_SLOT2: return AdsLimits.TYPES.ENERGY_2;
                    case Meta.EXPEDITION_SLOT3: return AdsLimits.TYPES.ENERGY_3;
                    case Meta.EXPEDITION_SLOT4: return AdsLimits.TYPES.ENERGY_4;
                    case Meta.EXPEDITION_SLOT5: return AdsLimits.TYPES.ENERGY_5;
                    default: return AdsLimits.TYPES.ENERGY;
                }
            },
            ...videoLivesTile
        };

        VirtualProducts.energyForVideoShort = {
            icon: "energy_for_video_json",
            title: "LivesShopWindow.products.energyForVideoShort",
            description: "EnergyForVideoProduct.description",
            rewardsIcon: "shop_energy_png",
            reward: RewardsConfig.EnergyForVideoShort,
            type: Product.TYPE_ADS,
            adsLimit: function () {
                switch (cleverapps.lives.locationConfig.slotId) {
                    case Meta.EXPEDITION_SLOT1: return AdsLimits.TYPES.ENERGY_1_SHORT;
                    case Meta.EXPEDITION_SLOT2: return AdsLimits.TYPES.ENERGY_2_SHORT;
                    case Meta.EXPEDITION_SLOT3: return AdsLimits.TYPES.ENERGY_3_SHORT;
                    case Meta.EXPEDITION_SLOT4: return AdsLimits.TYPES.ENERGY_4_SHORT;
                    case Meta.EXPEDITION_SLOT5: return AdsLimits.TYPES.ENERGY_5_SHORT;
                    default: return AdsLimits.TYPES.ENERGY_SHORT;
                }
            },
            ...videoLivesTile
        };
    }

    VirtualProducts.softCurrencyVerySmall = {
        icon: "shop_coins_very_small_png",
        title: "LivesShopWindow.products.softCurrencyVerySmall",
        rewardsIcon: "shop_coin_png",
        realProductId: "coins350",
        currency: "hard",
        type: Product.TYPE_HARD,
        price: 80,
        reward: RewardsConfig.SoftCurrencyVerySmall,
        prefab: bundles.tile_shop.jsons.softcurrencytile_prefab_json
    };

    VirtualProducts.softCurrencySmall = {
        icon: "shop_coins_small_png",
        title: "LivesShopWindow.products.softCurrencySmall",
        rewardsIcon: "shop_coin_png",
        realProductId: "coins1100",
        currency: "hard",
        type: Product.TYPE_HARD,
        price: 250,
        reward: RewardsConfig.SoftCurrencySmall,
        prefab: bundles.tile_shop.jsons.softcurrencytile_prefab_json
    };

    VirtualProducts.softCurrencyMedium = {
        icon: "shop_coins_medium_png",
        title: "LivesShopWindow.products.softCurrencyMedium",
        rewardsIcon: "shop_coin_png",
        realProductId: "coins3000",
        currency: "hard",
        type: Product.TYPE_HARD,
        price: 600,
        reward: RewardsConfig.SoftCurrencyMedium,
        prefab: bundles.tile_shop.jsons.softcurrencytile_prefab_json
    };

    VirtualProducts.softCurrencyLarge = {
        icon: "shop_coins_large_png",
        title: "LivesShopWindow.products.softCurrencyLarge",
        rewardsIcon: "shop_coin_png",
        realProductId: "coins7000",
        currency: "hard",
        type: Product.TYPE_HARD,
        price: 1400,
        reward: RewardsConfig.SoftCurrencyLarge,
        prefab: bundles.tile_shop.jsons.softcurrencytile_prefab_json
    };

    VirtualProducts.hardForVideo = {
        icon: "gold_for_video_json",
        attention: true,
        title: "TileShop.products.hardForVideo",
        rewardsIcon: "reward_gold_png",
        reward: RewardsConfig.HardForVideo,
        mainMonetizationReward: RewardsConfig.HardForVideoMainMon,
        type: Product.TYPE_ADS,
        adsLimit: function () {
            return AdsLimits.TYPES.HARD;
        },
        prefab: bundles.tile_shop.jsons.coinsproducttile_prefab_json,
        isEnabled: function () {
            // Old LimitedVideoTileModel.isEnabled - see videoLivesTile. inABExperiments gate is applied
            // by ShopProductSource.isProductEnabled.
            return this.free || connector.ads.isRewardedSupported;
        },
        isAttention: function () {
            return cleverapps.adsLimits.state(this.adsLimit()) === AdsLimits.STATE_READY && Boolean(this.attention);
        }
    };

    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        VirtualProducts.hardForVideo.rewardsIcon = "gold_small_png";
    }

    if (cleverapps.config.features.includes("caravan")) {
        Object.assign(VirtualProducts, {
            caravan0: {
                order: 0,
                title: "Caravan.Title0",
                price: 349,
                type: Product.TYPE_HARD,
                icon: bundles.caravan.frames.caravan_chest_0,
                person: bundles.caravan.frames.caravan_person_0,
                reward: RewardsConfig.Caravan0
            },

            caravan1: {
                order: 1,
                title: "Caravan.Title1",
                price: 699,
                type: Product.TYPE_HARD,
                icon: bundles.caravan.frames.caravan_chest_1,
                person: bundles.caravan.frames.caravan_person_1,
                value: "+50%",
                reward: RewardsConfig.Caravan1
            },

            caravan2: {
                order: 2,
                title: "Caravan.Title2",
                price: 1499,
                type: Product.TYPE_HARD,
                icon: bundles.caravan.frames.caravan_chest_2,
                person: bundles.caravan.frames.caravan_person_2,
                value: "+100%",
                reward: RewardsConfig.Caravan2
            }
        });
    }

    if (cleverapps.config.type === "battlefield") {
        Object.assign(VirtualProducts, {
            troops900: {
                probabilities: [0.5, 0.5, 0],
                price: 900,
                points: 1,
                stage: 0
            },
            troops1900: {
                probabilities: [0.4, 0.59, 0.01],
                price: 1900,
                points: 2,
                stage: 1
            },
            troops3800: {
                probabilities: [0.17, 0.8, 0.03],
                price: 3800,
                points: 3,
                stage: 2
            },
            troops7500: {
                probabilities: [0.01, 0.93, 0.06],
                price: 7500,
                points: 4,
                stage: 3
            }
        });
    }

    for (const key in VirtualProducts) {
        VirtualProducts[key].itemId = key;
    }

    if (cleverapps.config.name === "zenmatch") {
        VirtualProducts.hardForVideo = undefined;
    }
};
